import { SvgIcon } from '@mui/material';
import React from 'react'
export const DatabaseIcon = (props) => {
    return <SvgIcon {...props} enableBackground="new 0 0 48 48" height="24px" version="1.1" viewBox="0 0 48 48" width="24px">
            <g id="Expanded">
                <g>
                    <g>
                        <path d="M24,20c-11.215,0-20-3.953-20-9s8.785-9,20-9s20,3.953,20,9S35.215,20,24,20z M24,4C15.486,4,6,6.875,6,11s9.486,7,18,7     s18-2.875,18-7S32.514,4,24,4z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                    <g>
                        <path d="M24,28c-11.215,0-20-3.953-20-9v-8c0-0.553,0.447-1,1-1s1,0.447,1,1v8c0,4.125,9.486,7,18,7s18-2.875,18-7v-8     c0-0.553,0.447-1,1-1s1,0.447,1,1v8C44,24.047,35.215,28,24,28z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                    <g>
                        <path d="M24,37c-11.215,0-20-3.953-20-9v-9c0-0.553,0.447-1,1-1s1,0.447,1,1v9c0,4.125,9.486,7,18,7s18-2.875,18-7v-9     c0-0.553,0.447-1,1-1s1,0.447,1,1v9C44,33.047,35.215,37,24,37z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                    <g>
                        <path d="M24,46c-11.215,0-20-3.953-20-9v-9c0-0.553,0.447-1,1-1s1,0.447,1,1v9c0,4.125,9.486,7,18,7s18-2.875,18-7v-9     c0-0.553,0.447-1,1-1s1,0.447,1,1v9C44,42.047,35.215,46,24,46z" fill={props.style?.color} stroke={props.style?.color} strokeWidth="1" />
                    </g>
                </g>
            </g>
    </SvgIcon>
}